//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "#webapp/src/__schema__";
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// event-scheduler-suggested-room imports
import { eventSchedulerSuggestedRoomFragments } from "./EventSchedulerSuggestedRoom.gql";
import * as s from "./EventSchedulerSuggestedRoom.styles";
import { IContainer, IProps, IState } from "./EventSchedulerSuggestedRoomTypes";
// other components
import { InfoTip } from "#webapp/src/components/tool-tip";
// state
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
// material-ui
import { Close, Error } from "@clockwise/design-system/icons";
import { IconButton } from "@material-ui/core";

//////////////////
// COMPONENT
//////////////////
class EventSchedulerSuggestedRoomCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      hovered: false,
    };
  }

  // ~-~-~-~-~-~-~-
  // Handlers
  // ~-~-~-~-~-~-~-
  private onAddRoom = (room: ISchema.IRoom) => {
    if (this.props.onAdd) {
      this.props.onAdd(room);
    }
  };

  private onRemoveRoom = (room: ISchema.IRoom) => {
    if (this.props.onRemove) {
      this.props.onRemove(room);
    }
  };

  private onHoverRoom = (hovered: boolean) => {
    this.setState({ hovered });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderCapacity = (room: ISchema.IRoom) => {
    const capacity = room.reportedCapacity || room.estimatedCapacity;
    if (!capacity) {
      return <span />;
    }

    return (
      <div style={s.capacity}>
        Typically hosts {capacity} {capacity !== 1 ? "people" : "person"}
      </div>
    );
  };

  private maybeRenderImpact = (schedulingRoomImpact: ISchema.ISchedulingRoomImpact) => {
    const { available, tooSmall, tooLarge } = schedulingRoomImpact;
    return (
      <div
        style={{
          ...s.impact,
          alignItems:
            (!available && tooSmall) || (!available && tooLarge) || (tooSmall && tooLarge)
              ? "flex-start"
              : "center",
        }}
      >
        {!available || tooSmall || tooLarge ? <Error {...s.warningIcon} /> : ""}
        <div>
          {!available ? <div>Unavailable at the selected time</div> : ""}
          {tooSmall ? <div>Too small for your meeting</div> : ""}
          {tooLarge ? <div>Oversized for your meeting</div> : ""}
        </div>
      </div>
    );
  };

  public render() {
    const { room, schedulingRoomImpact, selected } = this.props;

    const containerStyle = selected
      ? s.suggestionSelected
      : this.state.hovered
      ? s.suggestionHovered
      : s.suggestion;

    const showTip = (this.props.onRemove && room.name.length > 29) || room.name.length > 37;

    return (
      <div
        style={containerStyle}
        onClick={() => this.onAddRoom(room)}
        onMouseEnter={() => this.onHoverRoom(true)}
        onMouseLeave={() => this.onHoverRoom(false)}
      >
        <div style={s.roomDetails.container}>
          <div style={{ maxWidth: this.props.onRemove ? 195 : "none" }}>
            {showTip ? (
              <InfoTip
                targetElement={<div style={s.roomDetails.name}>{room.name}</div>}
                text={room.name}
                tipType={"info"}
                iconStyle={{ display: "inline" }}
                position="left"
              />
            ) : (
              <div>{room.name}</div>
            )}
          </div>
          {this.renderCapacity(room)}
          {schedulingRoomImpact && this.maybeRenderImpact(schedulingRoomImpact)}
        </div>
        {this.props.onRemove ? (
          <IconButton {...s.close} onClick={() => this.onRemoveRoom(room)}>
            <Close {...s.icon} />
          </IconButton>
        ) : (
          ""
        )}
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const EventSchedulerSuggestedRoomRedux = connect(
  mapStateToProps,
  {},
)(EventSchedulerSuggestedRoomCmpt);

//////////////////
// RELAY
//////////////////
export const EventSchedulerSuggestedRoom = createFragmentContainer<IContainer>(
  EventSchedulerSuggestedRoomRedux,
  eventSchedulerSuggestedRoomFragments,
);
